import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '../ogComponent/table';
import { useNavigate } from 'react-router-dom';
import Spinner from '../ogComponent/spinner';

export default function FeeReport() {
    const navigate = useNavigate();
    const today = new Date().toISOString().split('T')[0]; // yyyy-mm-dd format

    const [startDate, setStartDate] = useState(today);
    const [endDate, setEndDate] = useState(today);
    const [data, setData] = useState([]);
    const [amount, setAmount] = useState("0");
    const [loading, setLoading] = useState(false); // Add loading state
    const [currentPage, setCurrentPage] = useState(1);

    const header = [
        { name: "Si_No", label: "#", active: true },
        { name: "user_id", label: "User Code", active: true },
        { name: "name", label: "Name", active: true },
        { name: "domain", label: "Domain", active: true },
        { name: "date", label: "Date", active: true },
        { name: "fee", label: "Fee", active: true },
    ];

    // Handle page change
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        // setSearchParams({ page: newPage });
    };

    const handleChange = (item) => {
        navigate(`/user/bill/${item.id}`);
    };

    const fetchTotal = async () => {
        setLoading(true); // Start loading
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API}/api/course/total-enrollment-amount-by-date/?start_date=${startDate}&end_date=${endDate}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    },
                }
            );
            setAmount(res.data.total_amount_paid);
        } catch (error) {
            console.error('Error fetching total amount:', error);
        } finally {
            setLoading(false); // Stop loading
        }
    };

    const fetchData = async () => {
        setLoading(true); // Start loading
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API}/api/course/student-enrollments-by-date/?start_date=${startDate}&end_date=${endDate}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    },
                }
            );

            const formattedData = res.data.enrollments.map((item, index) => ({
                Si_No: index + 1,
                user_id: item.student.student_code,
                name: (
                    <td
                        className="d-flex gap-3 align-items-center px-0"
                        style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    >
                        <img
                            style={{
                                width: "25px",
                                height: "25px",
                                flexShrink: 0,
                                borderRadius: "50%",
                            }}
                            src={item?.student?.profile_photo || "/assets/user.png"}
                            alt="user img"
                        />
                        <div style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                            {item?.student?.full_name || "N/A"}
                        </div>
                    </td>
                ),
                domain: item.course.course_name,
                date: item.enrollment_date,
                fee: item.amount_paid,
                id: item.id,
            }));

            setData(formattedData);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Stop loading
        }
    };

    useEffect(() => {
        fetchTotal();
        fetchData();
    }, [startDate, endDate]);

    return (
        <div className="px-4 py-3 w-100">
            <h2>Fee Report</h2>

            {/* Filter by date */}
            <div className="dateFilterContainer mb-3 d-flex gap-3 mt-md-2 justify-content-between">
                <div className="d-flex justify-content-center align-items-center">
                    <button className="btn h-75" style={{ backgroundColor: '#03689470' }}>Total Amount : <span className='fw-semibold ms-1'>{amount}</span></button>
                </div>

                <div className="d-flex gap-3">
                    <div className="startDate d-flex flex-column">
                        <label
                            htmlFor="startDate"
                            style={{ fontSize: "clamp(10px, 1.2vw, 13px)" }}
                            className="fw-bold"
                        >
                            Start Date
                        </label>
                        <input
                            id="startDate"
                            type="date"
                            className="rounded-1 px-2 px-md-3 py-1 bg-white"
                            style={{
                                border: "2px solid grey",
                                fontSize: "clamp(12px, 1.3vw, 15px)",
                            }}
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                        />
                    </div>
                    <div className="endDate d-flex flex-column">
                        <label
                            htmlFor="endDate"
                            style={{ fontSize: "clamp(10px, 1.2vw, 13px)" }}
                            className="fw-bold"
                        >
                            End Date
                        </label>
                        <input
                            id="endDate"
                            type="date"
                            className="rounded-1 px-2 px-md-3 py-1 bg-white"
                            style={{
                                border: "2px solid grey",
                                fontSize: "clamp(12px, 1.4vw, 16px)",
                            }}
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                        />
                    </div>
                </div>
            </div>

            {/* Conditional rendering based on loading state */}
            {loading ? (
                <Spinner />
            ) : data.length > 0 ? (
                <Table
                    header={header}
                    product={data}
                    loading={loading}
                    onRowClick={handleChange}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                />
            ) : (
                <div
                    className="d-flex justify-content-center align-items-end position-relative"
                    style={{ height: "50vh" }}
                >
                    <div
                        className="position-absolute top-0 start-0 w-100 h-100"
                        style={{
                            backgroundImage: 'url(/assets/file.png)',
                            backgroundSize: 'contain',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            opacity: 0.3,
                        }}
                    ></div>
                    <p className="m-0 fw-light fs-5 position-relative">No Fee Statements Found!</p>
                </div>
            )}
        </div>
    );
}